<template>
  <router-link v-if="to && !disabled" :to="to" :exact="exact">
    <slot></slot>
  </router-link>
  <a v-else-if="href && !disabled" :href="href" :target="target">
    <slot></slot>
  </a>
  <div v-else>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      required: false
    },
    exact: {
      type: Boolean,
      required: false
    },
    href: {
      type: String,
      required: false
    },
    target: {
      type: String,
      required: false
    },
    to: {
      type: Object,
      required: false
    }
  }
};
</script>
